import {Box} from "@mui/material";
import React, {FC} from "react";
import * as z from "zod";
import {emptyValue} from "@/helper/method";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import {useRejectExecute} from "@/service/instance.s";
import {useGlobalActions} from "@/store/global.c";
import {QueryObserverResult, RefetchOptions} from "@tanstack/react-query";
import {DialogFooter} from "@/widget/DialogModal/DialogModal";

export interface WriteRejectProps {
    instanceId: number;
    refetchExecutes: (options?: RefetchOptions) => Promise<QueryObserverResult>
}

const validationSchema = z.object({
    remark: z.string({message: "请填写拒绝原因"})
});

export type WriteRejectForm = z.infer<typeof validationSchema>

const defaultValues = emptyValue(validationSchema)

export const WriteReject: FC<WriteRejectProps> = ({instanceId, refetchExecutes}) => {
    const {
        handleSubmit,
        register,
        formState: {errors},
    } = useForm<WriteRejectForm>({
        resolver: zodResolver(validationSchema),
        defaultValues,
    });
    const {mutateAsync: rejectExecuteMutate} = useRejectExecute()
    const {setToast} = useGlobalActions()
    const {setDialogModal} = useGlobalActions()

    const onSubmit = async (values: WriteRejectForm) => {
        const result = await rejectExecuteMutate({...values, instanceId})
        if (result.code == 0) {
            setToast({message: result.msg, open: true, severity: 'success', duration: 2000});
            await refetchExecutes()
            setDialogModal({open: false})
        } else {
            setToast({message: result.msg, open: true, severity: 'error', duration: 2000});
        }
    }

    return <Box component={'form'} noValidate onSubmit={handleSubmit(onSubmit)}>
        <FormControl fullWidth={true}>
            <TextField
                multiline
                {...register("remark")}
                error={!!errors?.remark}
                helperText={errors?.remark?.message}
                rows={4}
                slotProps={{
                    input: {
                        sx: {height: 'auto'},
                    },
                }}
                placeholder="拒绝原因"
                fullWidth
            />
        </FormControl>
        <DialogFooter/>
    </Box>
}